import { IsNotEmpty } from "class-validator";

export default class DeleteDriverReq {
  @IsNotEmpty({
    message: "",
  })
  readonly driverId: number;

  constructor(arg: any) {
    arg = arg || {};
    this.driverId = arg.driverId;
  }
}
